export default class ToolTip {
  constructor() {

    this.isOpen = false;

    this.target = document.createElement('div');
    this.target.classList.add('css_tooltip');
    this.target.id = "css_tooltip";
    document.body.appendChild(this.target);

    this.lastPointerTarget = null;
    this.lastPointerType = "mouse";

    document.addEventListener("pointerdown", (e) => {
      //if (this.lastPointerType === "mouse") return;
      if (!this.isOpen) return;

      if (this.target.contains(e.target)) return;
      if (this.target && this.target.contains(e.target)) return;
      this.onClose();
    });

    this.addEvent();
  }

  addEvent(_target = document.body){
    const btnTargets = [..._target.querySelectorAll('.js-tooltip')];

    btnTargets.forEach(el=>{
      /*el.addEventListener('pointerenter',(e)=>{
        this.lastPointerType = e.pointerType;
        if (e.pointerType === "mouse") this.onOpen(e);
      });
      el.addEventListener('pointerleave',(e)=>{
        this.lastPointerType = e.pointerType;
        if (e.pointerType === "mouse") this.onClose();
      });*/

      el.addEventListener("pointerdown", (e) => {
        this.lastPointerType = e.pointerType;

        //if (e.pointerType !== "mouse") {
          e.stopPropagation();
          if(this.lastPointerTarget === e.target){
            this.onClose();
          } else {
            this.onOpen(e);
          }
        //}
      });
    });
  }

  onOpen(e){
    this.isOpen = true;
    const target = e.currentTarget;
    this.target.innerText = target.dataset.text;

    const rect = target.getBoundingClientRect();
    const left = rect.left + window.scrollX;
    const top = rect.top + rect.height + 12 + window.scrollY;
    this.target.style.left = left + 'px';
    this.target.style.top = top + 'px';

    this.target.style.display = 'block';
    this.lastPointerTarget = e.target;
  }
  onClose(){
    this.target.style.display = 'none';
    this.target.innerText = "";
    this.lastPointerTarget = null;
    this.isOpen = false;
  }


}
